// extracted by mini-css-extract-plugin
module.exports = {"root":"_2wid5","SloppyBorderMenuButtonNSkin":"_6oVfH","sloppyBorderMenuButtonNSkin":"_6oVfH","linkElement":"V1yYL","wrapper":"_17Nmk","label":"_3jfEa"};